import { observable } from 'mobx';

export class SigninPageModel {
  @observable
  loading: boolean = true;

  @observable
  hasError: boolean = false;
}